module.exports = __webpack_public_path__ + "cc13118671dd98a83ebce8c3bcb65e4f.pdf";